import { render, staticRenderFns } from "./AggregateLearningLeaderboardCreator.vue?vue&type=template&id=a1cc2c2a&scoped=true"
import script from "./AggregateLearningLeaderboardCreator.vue?vue&type=script&lang=js"
export * from "./AggregateLearningLeaderboardCreator.vue?vue&type=script&lang=js"
import style0 from "./AggregateLearningLeaderboardCreator.vue?vue&type=style&index=0&id=a1cc2c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cc2c2a",
  null
  
)

export default component.exports